import {messenger} from '@communication'

export default class PeerErrorProcedure{
  constructor () {
    this.name = 'peerErrorProcedure'
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:error', this.handler)
  }
  
  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handler = (event) => {
    // todo
    console.warn('peer error ', event)
   }
}
